// extracted by mini-css-extract-plugin
module.exports = {"root":"Banner_root__3d2hH","fixedBtn":"Banner_fixedBtn__2LKlS","box":"Banner_box__BTKki","titleLg":"Banner_titleLg__3wwEV","titleMd":"Banner_titleMd__xaMoS"};